import React, { ComponentProps } from 'react';
import { PlaceComment } from '~/api/places';
import { categoryIcon, categoryLabel } from '~/containers/Places/constants';
import StaffCommentRow from '~/components/StaffCommentRow/StaffCommentRow';

type IProps = Omit<
  ComponentProps<typeof StaffCommentRow>,
  'comment' | 'badge' | 'onHide' | 'onNotifyResident' | 'onBlockUser'
> & {
  comment: PlaceComment;
  onHide: (comment: PlaceComment) => void;
  onNotifyResident: (comment: PlaceComment) => void;
  onBlockUser?: (comment: PlaceComment) => void;
};

// A Places comment: the shared staff row, badged with its place and category.
const PlaceCommentRow = (props: IProps) => (
  <StaffCommentRow<PlaceComment>
    {...props}
    badge={
      <>
        {categoryIcon(props.comment.placeCategory)}
        {props.comment.placeName} · {categoryLabel(props.comment.placeCategory)}
      </>
    }
  />
);

export default PlaceCommentRow;
